<script setup>

import { ref, watch } from 'vue';
import { 
    getErreurTexteRequis,
    getErreurFichierRequis } from '@/scripts/controlesSaisie.js';
import Dialog from 'primevue/dialog';
import Formulaire from '@/components/generiques/Formulaire.vue';
import SaisieTexte from '@/components/generiques/SaisieTexte.vue';
import SaisieFichier from '@/components/generiques/SaisieFichier.vue';

const visible = defineModel('visible', {
    type: Boolean
});

const emit = defineEmits(['importModele']);

const importModele = ref(getImportModeleInitial());

function getImportModeleInitial() {
    return {
        fichier: null,
        nomModele: null
    };
}

function validerSaisie(modele) {
    const erreurs = {};
    erreurs.fichier = getErreurFichierRequis(modele.fichier);
    erreurs.nomModele = getErreurTexteRequis(modele.nomModele);
    return erreurs;
}

watch(() => visible.value, (visible) => {
    if (visible) {
        importModele.value = getImportModeleInitial();
    }
});

function validerFormulaire() {
    importModele.value.validationFormulaire = true;
}

function valider(importModele) {
    emit('importModele', importModele.fichier, importModele.nomModele);
}

</script>

<template>
    <Dialog 
    v-model:visible="visible" 
    modal 
    header="Import de modèle">
        <Formulaire 
            :objet="importModele"
            :fonction-validation-saisie="validerSaisie"
            @validation="() => valider(importModele)">
            <label class="intitule">Fichier :</label>
            <SaisieFichier v-model:valeur="importModele.fichier" :id-erreur="'fichier'" />
            <label class="intitule">Nom :</label>
            <SaisieTexte v-model:valeur="importModele.nomModele" :id-erreur="'nomModele'" :autofocus="true" />
        </Formulaire>
        <template #footer>
            <button 
                class="bouton btn-primaire fas fa-check" 
                @click="validerFormulaire()"/>
        </template>
    </Dialog>
</template>

<style scoped>

</style>